import { render, staticRenderFns } from "./_tabInvoice.vue?vue&type=template&id=3355a958&"
import script from "./_tabInvoice.vue?vue&type=script&lang=js&"
export * from "./_tabInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports